<template>
  <div class="margin-bottom-60">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <data-table :columns="employeeTableColumns" :tableData="revisionLogList" :showinrow="false">
      <template v-slot:rowcontent="slotprops">
        <div>
          <p>{{slotprops.value.record[slotprops.value.column.key]}}</p>

          <!-- dropdown section starts here -->
          <!-- <div class="action-section" v-if="slotprops.value.column.key=='action'">
            <img
              src="@/assets/group-2.png"
              class="pointer-cursor"
              @click="dropdown(slotprops.value.record)"
              alt="actionIcon"
            />
            <ul class="action-menu" v-show="employeeDocs[slotprops.value.index].showDropDown">
              <li>
                <span class @click="viewHistory(slotprops.value.record)">View History</span>
              </li>
            </ul>
          </div>-->
          <!-- dropdown section ends here -->

          <!-- dropdown section starts here -->
          <div class="action-section" v-if="slotprops.value.column.key=='action'">
            <img class="menu-icon" src="@/assets/group-2.png" alt="actionIcon" />
            <ul class="action-menu">
              <li>
                <span class @click="viewHistory(slotprops.value.index)">View History</span>
              </li>
            </ul>
          </div>
          <!-- dropdown section ends here -->
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      employeeTableColumns: [
        {
          label: "Applicable Till",
          key: "revised_applicable_to"
        },
        {
          label: "Applicable From",
          key: "revised_applicable_from"
        },
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Action",
          key: "action"
        }
      ],
      employeeDocs: [
      ],

      errmsg: "",
      toast: false,

      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },
      assignedComponentsList: [],
      parentRevisionLogList: [],
      revisionLogList: []
    };
  },

  activated() {

    this.employeeObject = this.getRecord;
    this.assignedComponentsList = [];

    if (this.employeeObject.EmployeeNonCTCComponent) {
      if (this.employeeObject.EmployeeNonCTCComponent.salary_component) {
        if (
          this.employeeObject.EmployeeNonCTCComponent.salary_component.length
        ) {
          this.employeeObject.EmployeeNonCTCComponent.salary_component.forEach(
            (element, index) => {
              let obj = {
                id: element.salary_component_id,
                applicableFrom_date: element.applicable_from,
                applicableTill_date: element.applicable_to,
                amount: element.amount,
                showDropDown: false,
                isEditable: false
              };
              this.assignedComponentsList.push(obj);
            }
          );
        }
      }
    }


    this.getEmployeeComponentsRevisionLogs();


    // if (this.assignedComponentsList.length) {
    //   this.assignedComponentsList.forEach((element, index) => {
    //     this.getEmployeeComponentsRevisionLogs(element);
    //   });
    // }
  },

  computed: {
    ...mapState({
      orgData: state => state.onboard.organization.state.data[0],
      getRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.record,
    }),
    // ...mapState("onboard/organization", {
    //   orgData: state => state.data[0]
    // }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
      // getRecord: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/record"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },

  methods: {
    ...mapActions({
      fetchComponentsRevisionLog:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchComponentsRevisionLog",
      act_setSelectedLog:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/setSelectedRevisionLog"
    }),

    async getEmployeeComponentsRevisionLogs() {
      try {
        // let obj = {
        //   component_id: component.id,
        //   employee_id: this.employeeObject.id
        // };

        let obj = {
          employee_id: this.employeeObject.id
        };

        let res = await this.fetchComponentsRevisionLog(obj);
        //console.log("getEmployeeComponentsRevisionLogs:", res);

        this.revisionLogList = [];
        if (res.status == 200 || res.status == 201) {
          if (res.data.payload) {
            let dataArr = res.data.payload.data;

            if (dataArr.length) {
              dataArr.forEach((item, index) => {
                this.parentRevisionLogList.push(item);
                let logsArray = item.log_details;
                if (logsArray.length) {
                  let logsArrayCount = logsArray.length;
                  let latestLogObject = logsArray[logsArrayCount - 1];
                  latestLogObject.status = this.getStatus(latestLogObject);
                  this.revisionLogList.push(latestLogObject);
                }
              });
            }
          }

          //console.log("revisionLogList:", this.revisionLogList);

          // this.componentsList = res.data.payload.data;
          // if (this.employeeObject.assignedComponentsList) {
          //   if (this.employeeObject.assignedComponentsList.salary_component) {
          //     if (
          //       this.employeeObject.assignedComponentsList.salary_component
          //         .length
          //     ) {
          //       this.employeeObject.assignedComponentsList.salary_component.forEach(
          //         (element, index) => {
          //           this.setSalaryComponetsData(element, index);
          //         }
          //       );
          //       //console.log(
          //         "assignedComponentsList:",
          //         this.assignedComponentsList
          //       );
          //     }
          //   }
          // }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        //console.log("error:", err);
      }
    },

    getStatus(latestLogObject){

      let currentDate = new Date();
      let applicable_from = new Date(latestLogObject.revised_applicable_from) ;
      let applicable_to = new Date(latestLogObject.revised_applicable_to) ;
      
      
      if (latestLogObject.unassign_date){
        return "Unassigned";
      }else if (currentDate < applicable_from){
        return "Scheduled";
      }else if (currentDate > applicable_from && currentDate < applicable_to){
        return "Active";
      }else{
        return "Completed";
      }

    },

    async viewHistory(index,record) {
      let parentLogObject = this.parentRevisionLogList[index];

      try {
        await this.act_setSelectedLog({ record: parentLogObject });
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/componentHistory`
          });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }

    },

    getEmpEncryptedString() {
      return this.$route.query.employee;
    },

    dropdown(slots) {
      let idx = this.employeeDocs.findIndex(obj => {
        return obj.id == slots.id;
      });
      this.employeeDocs.forEach((data, index) => {
        if (index !== idx) {
          data.showDropDown = false;
        }
      });
      // //console.log('customEmpList',this.customEmpList);
      if (idx > -1) {
        this.employeeDocs[idx].showDropDown = this.employeeDocs[idx]
          .showDropDown
          ? false
          : true;
        this.employeeDocs = [...this.employeeDocs];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -160px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #979797;
        }
      }
    }
  }
}

.margin-bottom-60 {
  margin-bottom: 60px;
}
</style>
